import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { RowWithSingleField, YesNoRow } from "../Components/SidebarComponents";

export const MiniSection = ({ hasCoverage, coverage, title }) => {
    return (
        <div className="mini-section">
            <div className="row">
                <h4>{title}</h4>
            </div>
            {!hasCoverage && (
                <>
                    <YesNoRow title="Coverage" isYes={hasCoverage} />
                </>
            )}
            {hasCoverage && (
                <>
                    {coverage.typeOfCoverage === "Insurance" && (
                        <RowWithSingleField title="Company" value={coverage.companyName} />
                    )}
                    {coverage.typeOfCoverage !== "Insurance" && (
                        <RowWithSingleField title="Type" value={coverage.typeOfCoverage} />
                    )}
                    {coverage.memberNumber != null && (
                        <RowWithSingleField title="Member #" value={coverage.memberNumber} />
                    )}
                </>
            )}
        </div>
    );
};

export const InterviewSidebarCoverage = ({ coverage, ...props }) => {
    return (
        <InterviewSidebarSection title="Coverage" {...props}>
            {coverage?.thirdPartyLiability?.typeOfAccident !== null && (
            <>
                <h4>Accident or Crime</h4>
                {coverage?.thirdPartyLiability?.typeOfAccident.toUpperCase() === "VICTIM OF VIOLENT CRIME" && (
                <YesNoRow title={coverage?.thirdPartyLiability?.typeOfAccident} isYes={coverage.thirdPartyLiability.typeOfAccident}/>
                )}

                {coverage?.thirdPartyLiability?.typeOfAccident.toUpperCase() !== "VICTIM OF VIOLENT CRIME" && (
                <YesNoRow title={"accident " + coverage?.thirdPartyLiability?.typeOfAccident} isYes={coverage.thirdPartyLiability.typeOfAccident}/>
                )}

                {coverage?.thirdPartyLiability?.typeOfAccident.toUpperCase() === "VICTIM OF VIOLENT CRIME" && (
                    <YesNoRow title="Filed Charges?" isYes={coverage.thirdPartyLiability.hasChargesBeenFiledForViolentCrime} />
                )}                
            </>
            )}
            <MiniSection
                coverage={coverage?.primaryCoverage}
                hasCoverage={coverage.hasCoverage}
                title="Primary Coverage"
            />
            <MiniSection
                coverage={coverage.supplementalCoverage}
                hasCoverage={coverage.hasSupplementalCoverage}
                title="Supplemental Coverage"
            />
        </InterviewSidebarSection>
    );
};
